<ng-container *ngIf="isLoaded$ | async">
  <app-tap-dashboard-chart [showSpinner$]="showSpinner$.asObservable()"
                           [chartData]="chartData"
                           [chartConfig]="chartConfig"
                           [chartLegend]="chartLegend"
                           [popOutWidth]="'70%'"
                           (pointRender)="onPointRender($event)"></app-tap-dashboard-chart>
</ng-container>

<ng-template #chartLegend>
  <widget-legend [legendData]="legendData"></widget-legend>
</ng-template>
